"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const flatControlsArray_1 = __importDefault(require("../flatters/flatControlsArray"));
const updateControlById_1 = __importDefault(require("./updateControlById"));
const calculateControlContextFromParentInfo_1 = __importDefault(require("./calculateControlContextFromParentInfo"));
const addControlsToParent = ({ buildOrders, flattedControls, parentId, controlsToAdd, shouldNotResetDynamicLoadingEnabled, }) => {
    const { buildOrders: buildOrdersAfterUpdate, flattedControls: flattedControlsAfterUpdate, } = (0, updateControlById_1.default)({
        buildOrders,
        flattedControls,
        controlId: parentId,
        dataToUpdate: {
            controls: controlsToAdd,
        },
        shouldNotResetDynamicLoadingEnabled,
    });
    const newParentInfo = flattedControlsAfterUpdate[parentId];
    if (!newParentInfo) {
        throw new Error('No parent info found');
    }
    const parentPath = newParentInfo.path || [];
    const newFlattedControls = (0, flatControlsArray_1.default)({
        controls: controlsToAdd,
        parentControlId: parentId,
        initialObject: flattedControlsAfterUpdate,
        context: (0, calculateControlContextFromParentInfo_1.default)(newParentInfo),
        path: parentPath,
    });
    return {
        flattedControls: newFlattedControls,
        buildOrders: buildOrdersAfterUpdate,
    };
};
exports.default = addControlsToParent;
